import { HTTP } from '@/http'
// initial state
const state = {
  directionStatistic: [],
  smallPerronObjects: [],
  smallPerronPreloader: true,
  perronObjects: [],
  perronAllObjects: [],
  perronStaff: [],
  perronStands: [],
  dirStatPreloader: true,
  perronPreloader: true,
  flightObjects: []
}
// mutations
const mutations = {
  setDirectionStatistic: function (state, value) {
    state.directionStatistic = value
  },
  setDirStatPreloaderState: function (state, value) {
    state.dirStatPreloader = value
  },
  setSmallPerronObjects: function (state, value) {
    state.smallPerronObjects = value
  },
  setSmallPerronPreloaderState: function (state, value) {
    state.smallPerronPreloader = value
  },
  setPerronObjects: function (state, value) {
    state.perronObjects = value
  },
  setPerronAllObjects: function (state, value) {
    state.perronAllObjects = value
  },
  setPerronStaff: function (state, value) {
    state.perronStaff = value
  },
  setPerronStands: function (state, value) {
    state.perronStands = value
  },
  setPerronPreloaderState: function (state, value) {
    state.perronPreloader = value
  },
  setFlightObjects: function (state, value) {
    state.flightObjects = value
  },
}
// actions
const actions = {
  async updateDirectionStatistic(context, params) {
    let access = context.rootGetters.chechAccess('wm')
    if (!access) {
      context.commit('setDirStatPreloaderState', false)
      return false
    }
    let d = new Date()
    let defaultParams = { year: d.getFullYear() }
    params = params || defaultParams

    context.commit('setDirStatPreloaderState', true)
    await HTTP.post('/api/direction-statistic', {
      year: params.year
    })
      .then(response => {
        if (response.status === 200) context.commit('setDirectionStatistic', response.data)
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
      })
    context.commit('setDirStatPreloaderState', false)
  },
  async updateSmallPerronObjects (context, params) {
    let access = context.rootGetters.chechAccess('ap')
    if (!access) {
      context.commit('setSmallPerronPreloaderState', false)
      return false
    }
    context.commit('setSmallPerronPreloaderState', true)
    await HTTP.get('/api/perron-map')
    .then(response => {
      if (response.status === 200) context.commit('setSmallPerronObjects', response.data)
    })
    .catch(e => {
      this.errorMessage = e
      this.dispatch('errorProcess', e)
    })
    context.commit('setSmallPerronPreloaderState', false)
  },
  async updatePerronObjects (context, params) {

    let access = context.rootGetters.chechAccess('ap')
    if (!access) {
      context.commit('setPerronPreloaderState', false)
      return false
    }
    if (!params.notLoading) {
      context.commit('setPerronPreloaderState', true)
    }
    await HTTP.get('/api/perron-map')
      .then(response => {
        if (response.status === 200) context.commit('setPerronObjects', response.data)
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
      })
    context.commit('setPerronPreloaderState', false)
  },
  async updateFlightObjects(context, params) {
    let access = context.rootGetters.chechAccess('tm')
    if (!access) {
      context.commit('setPerronPreloaderState', false)
      return false
    }
    context.commit('setPerronPreloaderState', true)
    await HTTP.get('/api/flight-map')
      .then(response => {
        if (response.status === 200) {
          response.data.arr.forEach(element => {
            if(!element.depTimeFact) {
              element.depTimeFact = element.depTimePlan
            }
            if(!element.arrTimeCalc) {
              element.arrTimeCalc = element.arrTimePlan
            }
          });
          context.commit('setFlightObjects', response.data)}
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
      })
    context.commit('setPerronPreloaderState', false)
  },
  async updatePerronObjectsAll (context, params) {
    await HTTP.get('/api/object-map')
      .then(response => {
        if (response.status === 200) context.commit('setPerronAllObjects', response.data)
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
      })
  },
  async updatePerronStaff (context, params) {
    await HTTP.get('/api/staff-map')
      .then(response => {
        if (response.status === 200) context.commit('setPerronStaff', response.data)
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
      })
  },
  async updatePerronStands (context, params) {
    await HTTP.get('/api/stands-map')
      .then(response => {
        if (response.status === 200) context.commit('setPerronStands', response.data)
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
      })
  }
}
// getters
const getters = {
  getDirectionStatistic(state) {
    return state.directionStatistic
  },
  getDirStatPreloader(state) {
    return state.dirStatPreloader
  },
  getSmallPerronObjects (state) {
    return state.smallPerronObjects
  },
  getSmallPerronPreloader (state) {
    return state.smallPerronPreloader
  },
  getPerronObjects (state) {
    return state.perronObjects
  },
  getPerronAllObjects (state) {
    return state.perronAllObjects
  },
  getPerronStaff (state) {
    return state.perronStaff
  },
  getPerronStands (state) {
    return state.perronStands
  },
  getPerronPreloader (state) {
    return state.perronPreloader
  },
  getFlightObjects(state) {
    return state.flightObjects
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
